import React, { useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';
import Tooltip from "@material-ui/core/Tooltip";
import {Select,FormControl, InputBase} from "@material-ui/core";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

const CssSelect = withStyles({
  root: {
    width: "100%",
    color:'#fff',
    marginTop: 16,
    fontSize:'1rem',
    fontFamily: 'Cera CY',
    fontWeight: 400,
    background:'none', 
    "& :before" : {
      borderColor: "white"
    },
    "& :after" : {      
        borderColor: "white"      
    },
    '&:before' : {
      borderBottom: '1px solid #fff'
    },     
    "& .MuiInput-underline:before": {
      borderBottomColor: "green"
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green"
    },
    'input + &' : {
      //color:'#fff'
    } ,
    "& .MuiInput-underline":{
      color: "pink"
    },
    // input:{
    //   color:'white',
    //   backgroundColor:'white',
      
    //   "& .MuiInput-underline":{
        
    //     color: "pink"
    //   },
    //   "& :before" : {
    //     borderColor: "white"
    //   },
    //   "& :after" : {      
    //       borderColor: "white"      
    //   },
    //   '&:before' : {
    //     borderBottom: '1px solid #fff'
    //   },
    // },
   
    // "& :before" : {
    //   borderColor: "white"
    // },
    // "& :after" : {      
    //     borderColor: "white"      
    // },
    // '&:before' : {
    //   borderBottom: '1px solid #fff'
    // },     
  },
  //root,select,filled,outlined,selectMenu,disabled,icon,iconOpen,iconFilled,iconOutlined,nativeInput.
  select:{
    background:'none',
    
  },
  input:{
    color:'pink'
  },
  filled:{
    background:'none',
    borderColor:'#fff'
  },
  outlined:{
    color:'#djkfh'
  },
  nativeInput: {
    borderColor:'#fff',
    color:'pink',
    '&:before' : {
      borderColor: '1px solid #fff'
    },
    '&:after' : {
      borderColor: '1px solid #fff'
    },
  },  
  icon:{
    color:'#fff'
  },
  '&:before' : {
    borderBottom: '1px solid #fff'
  },
})(Select);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    background:'none'
  },
  // margin: {
  //   margin: theme.spacing(1)
  // }
}));

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);

const StyledTextField = withStyles({
  root: {
    //background: "white",
    color:'white',
    
    "& label": {
      color: "white"
    },
    "& :before" : {
      borderColor: "white"
    },
    "& :after" : {
      "& :hover":{
        borderColor: "white"
      }
    },
    "&:hover" : {
      borderColor: "white"
    },
    "& :focus" : {
      borderColor: "white"
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "white"
    },
    "& .MuiAutocomplete-input" : {
      color: "white"
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: '2px solid white'
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white"
      },
      "&:hover fieldset": {
        borderColor: "white"
      },
      "&.Mui-focused fieldset": {
        borderColor: "white"
      }
    }
  }
})(InputBase);

const BootstrapInput = withStyles((theme) => ({ 
  input: {    
    borderBottom:'1px solid #fff',
    '&:hover': {    
      borderBottom: '2px solid #fff',  
      padding: '6px 0 6px'   
    },
  },
}))(InputBase);


export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <FormControl className={classes.root} noValidate disabled={props.disabled}>
      <InputLabel style={{color:'#fff'}} id={`${props.id}-label`}>{props.label}</InputLabel>
      <CssSelect
        //input ={StyledTextField}
        size="small"
        label={props.label}
        select 
        //className={classes.margin}
        input={<BootstrapInput />}
        //variant="filled"
        // type={props.type}
        // error={props.error}
        //defaultValue={props.defaultValue}
        value={props.value}
        // helperTooltip={props.helperText}
        onChange={props.onChange}
        labelId = {`${props.id}-label`}
        id = {props.id}
        hint={props.hint}  
      >
        
        {props.data.map((el,i) => {
          return (
            props.renderOption(el,i)
          )
        })}
        </CssSelect>
    </FormControl>
  );
}
